import React from "react";
import { Container } from "reactstrap";
import styled from 'styled-components'
import { useTranslation } from 'react-i18next';

const Header = styled.div`
  margin-top: -200px;
`

function IndexHeader() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div
        className="page-header section-dark"
        style={{
          backgroundImage:
            "url(" + require("assets/img/truck1.jpg") + ")"
        }}
      >
        <div className="filter" />
        <div className="content-center">
          <Container>
            <div className="title-brand">
              <h1 className="presentation-title"> <Header>AUSTRUM</Header></h1>
            </div>
            <h2 className="presentation-subtitle text-center">
              {t('MainTitle')}
            </h2>
          </Container>
        </div>
        <div
          className="moving-clouds"
          style={{
            backgroundImage: "url(" + require("assets/img/clouds.png") + ")"
          }}
        />
      </div>
    </>
  );
}

export default IndexHeader;
